import { render } from "./InvoiceRegistrationAdd.vue?vue&type=template&id=2bba60f0"
import script from "./InvoiceRegistrationAdd.vue?vue&type=script&lang=js"
export * from "./InvoiceRegistrationAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__